import CircularProgress from "@mui/material/CircularProgress";
import { Button } from "~/shared/components/MuiComponents.jsx";
import {
  kickAmaOrange,
  kickBlue,
  kickNavy,
} from "~/shared/styles/baseStyles.js";

// One on-brand card for every moment the patient is kept off the payment
// form: loading it, settling a Klarna attempt, or a provider error. It sits
// inside the checkout chrome (CheckoutInterstitial in paymentDetails.jsx), so
// a detour never looks like a different site or a half-rendered page.
const cardStyle = {
  border: "1px solid #C4C4C4",
  borderRadius: "4px",
  padding: "32px 24px",
  textAlign: "center",
  maxWidth: "520px",
  width: "100%",
  boxSizing: "border-box",
  margin: "0 auto",
};
const titleStyle = {
  fontFamily: "Spectral-Bold",
  fontSize: "24px",
  color: kickBlue,
  margin: "16px 0 8px",
};
const messageStyle = {
  fontSize: "17px",
  color: kickNavy,
  margin: "0 0 20px",
};
const primaryButtonStyle = {
  backgroundColor: kickAmaOrange,
  color: kickNavy,
  textTransform: "unset",
  fontSize: "16px",
  fontWeight: "bold",
  minWidth: "260px",
  borderRadius: "4px",
};
const linkButtonStyle = {
  display: "block",
  margin: "8px auto 0",
  padding: "12px 8px",
  background: "none",
  border: 0,
  color: kickBlue,
  textDecoration: "underline",
  cursor: "pointer",
  fontSize: "16px",
  fontFamily: "inherit",
};

// The orange primary action; pass component="a" and href for a link.
export function StatusButton({ style, ...rest }) {
  return <Button style={{ ...primaryButtonStyle, ...style }} {...rest} />;
}

// The underlined secondary action under the primary one.
export function StatusLinkButton({ style, ...rest }) {
  return (
    <button type="button" style={{ ...linkButtonStyle, ...style }} {...rest} />
  );
}

// messageRole is "status" (polite) while waiting and "alert" for an error.
export default function CheckoutStatusCard({
  spinner = false,
  title,
  message,
  messageRole = "status",
  actions = null,
  testID,
}) {
  return (
    <div style={cardStyle} data-testid={testID}>
      {spinner && <CircularProgress style={{ color: kickNavy }} />}
      <h3 style={titleStyle}>{title}</h3>
      <p role={messageRole} style={messageStyle}>
        {message}
      </p>
      {actions}
    </div>
  );
}
